import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { TextButton, Heading } from '@trainline/depot-web';
import { css } from 'aphrodite/no-important';
import dayjs from 'dayjs';

import { useFetchJourney } from '@contactcentre-web/hooks/api/useFetchJourney';
import Loader from '@contactcentre-web/common/Loader';

import { JourneyTrackCard } from '../JourneyTrack/JourneyTrackCard';
import messages from '../../messages';

import styles from './styles';

export const JourneyDetails = () => {
  const history = useHistory();
  const location = useLocation();

  const { loading, journey } = useFetchJourney();

  const handleGoBack = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('journey');
    const newSearch = searchParams.toString();
    const newPath = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
    history.replace(newPath);
  };

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <div className={css(styles.header)}>
        <Heading typeStyle="title2" as="h2">
          {dayjs(journey.trackingStartedDateTime).format('D MMMM YYYY')}
        </Heading>
        <TextButton
          onClick={handleGoBack}
          text="Back to weekly roll-up"
          typeSize="small"
          buttonType="inline"
          fontWeight="regular"
        />
      </div>
      <Heading typeStyle="title3" as="h3" className={css(styles.journeyDetailsHeading)}>
        <FormattedMessage {...messages.journeyDetails} />
      </Heading>
      <JourneyTrackCard />
    </div>
  );
};
